module.exports = __webpack_public_path__ + "img/pathways_logo.b9fa86ff.png";